var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C6.5 12.288 6.60123 12.5415 6.81493 12.7604L15.7342 21.6889C15.9254 21.8963 16.1728 22 16.4652 22C17.0501 22 17.5 21.5507 17.5 20.9516C17.5 20.6521 17.3763 20.3986 17.1963 20.2028L9.00818 12L17.1963 3.79724C17.3763 3.60138 17.5 3.33641 17.5 3.04839C17.5 2.44931 17.0501 2 16.4652 2C16.1728 2 15.9254 2.10369 15.7342 2.29954L6.81493 11.2396C6.60123 11.447 6.5 11.712 6.5 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.bb7649dd411676fa6d39eddbf68870ea.svg";
export { ForwardRef as ReactComponent };